import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';

export const StyledContainer = styled(Box)``;
export const StyledContent = styled(Box)``;
export const StyledHeaderContainer = styled(Box)``;
export const StyledHeaderStart = styled(Box)``;
export const StyledHeaderEnd = styled(Box)``;

const containerStyles: StyleSystemProps = {};

const contentStyles: StyleSystemProps = {};

const headerContainerStyles = (containerEdgeSize: number): StyleSystemProps => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingX: containerEdgeSize,
  marginBottom: '24px',
  alignItems: 'center',
});

const headerStartStyles: StyleSystemProps = {};

const headerEndStyles: StyleSystemProps = {
  marginLeft: 5,
};

export const styles = {
  container: containerStyles,
  content: contentStyles,
  header: headerContainerStyles,
  headerStart: headerStartStyles,
  headerEnd: headerEndStyles,
};
